import React from 'react';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import PricingSection from '../components/PricingSection';
import TransformationsSection from '../components/TransformationsSection';
import StatsSection from '../components/StatsSection';
import FAQSection from '../components/FAQSection';
import FooterSection from '../components/FooterSection';
import WhatsAppButton from '../components/WhatsAppButton';
import useScrollReveal from '../hooks/useScrollReveal';

const HomePage = () => {
  useScrollReveal();
  
  return (
    <div className="relative">
      <HeroSection />
      <AboutSection />
      <PricingSection />
      <TransformationsSection />
      <StatsSection />
      <FAQSection />
      <FooterSection />
      <WhatsAppButton />
    </div>
  );
};

export default HomePage;